import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { DataServiceService } from './data-service.service';
interface LoginResponse {
  UserCode: string;
  DeptName: any;
  token:string;
  username: string;
  dashboardnoofdays: string;
}
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public isVisible: boolean = true;
  set(){
    this.isVisible = true;
    setTimeout(()=> this.isVisible = false,2500)
  }
  get(){
    this.isVisible
  }
  // API path
  basePath = 'http://localhost:8000/';
  is_logged=false
  constructor(
    private router: Router,
    private http: HttpClient,
    private dataService : DataServiceService
  ) { }

  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  // Handle errors
  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    return throwError(
      'Something bad happened; please try again later.');
  }


  // Verify user credentials on server to get token
  loginForm(data: any): Observable<LoginResponse> {
    return this.http
      .post<LoginResponse>(this.basePath + 'api.php', data, this.httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      );
  }

  // After login save token and other values(if any) in localStorage
  setUser(resp: LoginResponse) {
    localStorage.setItem('email', resp.UserCode);
    localStorage.setItem('DeptName', resp.DeptName);
    localStorage.setItem('token', resp.token);
    localStorage.setItem('noofdays', resp.dashboardnoofdays);
    this.router.navigate(['/webqnex']);
    this.is_logged=true
  }

  setMenu(menu:[]){
    localStorage.setItem('Menu', JSON.stringify(menu));
  }

  // Checking if token is set
  isLoggedIn() {
    return localStorage.getItem('token') != null;
  }

  isAccessable(url: string){
    let menuList: any=[];
    //console.log(url);
    let urltext = url.replace('/webqnex/','');
    //console.log(urltext);
    menuList = this.dataService.menuRightsList;
    console.log(menuList);
    let accessable: boolean = false;
    for (let i = 0; i < menuList.length; i++) {
      let pageName = menuList[i]['pageName'];
      if (pageName === urltext) {
        accessable = true;
      }
    }
    return accessable;
  }

  // After clearing localStorage redirect to login screen
  logout() {
    localStorage.clear();
    this.router.navigate(['/auth/login']);
  }


  // Get data from server for Dashboard
  getData(data:any): Observable<LoginResponse> {
    return this.http
      .post<LoginResponse>(this.basePath + 'api.php', data, this.httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      );
  }
}

